import React, { useState } from 'react';
import { Loader2, Ticket } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import api, { formatPaise, formatError } from '@/lib/api';

/** "Have a coupon code?" box. Coupon money is added to the wallet; onRedeemed gets the new balance. */
export default function CouponRedeem({ onRedeemed }) {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);

  const redeem = async () => {
    if (!code.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post('/api/wallet/redeem', { code });
      toast.success(`${formatPaise(data.amount_paise)} added to your wallet`);
      setCode('');
      onRedeemed?.(data.balance_paise);
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "We couldn't use that code.");
    }
    setBusy(false);
  };

  return (
    <div className="flex gap-2" data-testid="coupon-redeem">
      <div className="relative flex-1">
        <Ticket className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input value={code} onChange={e => setCode(e.target.value)} onKeyDown={e => e.key === 'Enter' && redeem()}
          placeholder="Have a coupon code?" className="pl-9 uppercase" data-testid="coupon-input" />
      </div>
      <Button variant="outline" onClick={redeem} disabled={busy || !code.trim()} data-testid="coupon-apply-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Apply'}
      </Button>
    </div>
  );
}
